let actions = {
    updateLoggingIn({commit},loginData){
        /***
         * Acción que llama a la mutación de inicio de sesión
         */
        commit('updateLoggingIn',loginData)
    },
    updateToken({commit},tokenData){
        /***
         * Acción que llama a la mutación de actualización del token
         */
        commit('updateToken',tokenData)
    },
    logout({commit}) {
        /***
         * Acción que llama a la mutación de cierre de sesión
         */
        commit('logout','');
    },
    resetState({commit}) {
        commit('resetState','');
    },
    idleSet({commit}) {
        commit('idleSet');
    },
    setResetUser({commit},resetData){
        /***
         * Acción que llama a la mutación de reseteo de contraseña
         */
        commit('updateLoggingIn',resetData)
    },
    setLogoutState({commit},status) {
        commit('setLogoutState',status)
    },
    setActivityTypeSubcategory ({commit}, subcategory) {
        commit('setActivityTypeSubcategory', subcategory)
    },
    pushAssessment ({commit}, payload) {
        commit('pushAssessment', payload)
    },
    pushResumeAssessment ({commit}, payload) {
        commit('pushResumeAssessment', payload)
    },
    newAssesment ({commit}) {
        commit('newAssesment')
    },
    newStudy ({commit}, payload) {
        commit('newStudy', payload)
    },
    newSpouse ({commit}, payload) {
        commit('newSpouse', payload)
    },
    setSalesData ({commit}, payload) {
        commit('setSalesData', payload)
    },
    setSalesDataComputed ({commit}, payload) {
        commit('setSalesDataComputed', payload)
    },
    setSalesDataPopulate ({commit}, payload) {
        commit('setSalesDataPopulate', payload)
    },
    setCostsProductLine ({commit}, payload) {
        commit('setCostsProductLine', payload)
    },
    setPymeCostsProductLine ({commit}, payload) {
        commit('setPymeCostsProductLine', payload)
    },
    setCostsProductionItem ({commit}, payload) {
        commit('setCostsProductionItem', payload)
    },
    setPymeCostsProductLineItems ({commit}, payload) {
        commit('setPymeCostsProductLineItems', payload)
    },
    setGeneralCosts ({commit}, payload) {
        commit('setGeneralCosts', payload)
    },
    setFinancialObligations ({commit}, payload) {
        commit('setFinancialObligations', payload)
    },
    setAgroFinancialObligations ({commit}, payload) {
        commit('setAgroFinancialObligations', payload)
    },
    setAgroHistoricalYields({commit}, payload) {
        commit('setAgroHistoricalYields', payload)
    },
    setCashFlow ({commit}, payload) {
        commit('setCashFlow', payload)
    },
    setAgroInventory ({commit}, payload) {
        commit('setAgroInventory', payload)
    },
    setAgroEstate ({commit}, payload) {
        commit('setAgroEstate', payload)
    },
    setAgroMachinery ({commit}, payload) {
        commit('setAgroMachinery', payload)
    },
    setAgroProduct ({commit}, payload) {
        commit('setAgroProduct', payload)
    },
    setAgroSalary ({commit}, payload) {
        commit('setAgroSalary', payload)
    },
    setAgroExpenses ({commit}, payload) {
        commit('setAgroExpenses', payload)
    },
    setAgroLabour ({commit}, payload) {
        commit('setAgroLabour', payload)
    },
    setAgroAnotherExpenses ({commit}, payload) {
        commit('setAgroAnotherExpenses', payload)
    },
    setAgroSeasonalSales ({commit}, payload) {
        commit('setAgroSeasonalSales', payload)
    },
    setAgrocashFlowFamilyExpensesMonths ({commit}, payload) {
        commit('setAgrocashFlowFamilyExpensesMonths', payload)
    },
    setAgrocashFlowFull ({commit}, payload) {
        commit('setAgrocashFlowFull', payload)
    },
    setMicroBalance ({commit}, payload) {
        commit('setMicroBalance', payload)
    },
    setSpouseBalance ({commit}, payload) {
        commit('setSpouseBalance', payload)
    },
    setCashFlowBalance({commit}, payload) {
        commit('setCashFlowBalance', payload)
    },
    setTransportCosts ({commit}, payload) {
        commit('setTransportCosts', payload)
    },
    setPymeTransportCosts ({commit}, payload) {
        commit('setPymeTransportCosts', payload)
    },
    setMonthlyNumber ({commit}, payload) {
        commit('setMonthlyNumber', payload)
    },
    editCostsProductLine ({commit}, payload) {
        commit('editCostsProductLine', payload)
    },
    setCostsProductLineItems ({commit}, payload) {
        commit('setCostsProductLineItems', payload)
    },
    setCostsProductionItems ({commit}, payload) {
        commit('setCostsProductionItems', payload)
    },
    setCostsDataPopulate ({commit}, payload) {
        commit('setCostsDataPopulate', payload)
    },
    setTotalCostsComputed ({commit}, payload) {
        commit('setTotalCostsComputed', payload)
    },
    setCatalogs ({commit}, payload) {
        commit('setCatalogs', payload)
    },
    setCatalogSales ({commit}, payload) {
        commit('setCatalogSales', payload)
    },
    setCatalogCosts ({commit}, payload) {
        commit('setCatalogCosts', payload)
    },
    resetSalesCosts ( {commit}) {
        commit('resetSalesCosts')
    },
    resetCosts ( {commit}) {
        commit('resetCosts')
    },
    setEditProductIndex ( {commit}, payload ) {
        commit('setEditProductIndex', payload)
    },
    setOperatingExpenses ( {commit}, payload ) {
        commit('setOperatingExpenses', payload)
    },
    setInventory ( {commit}, payload ) {
        commit('setInventory', payload)
    },
    setReferences ( {commit}, payload ) {
        commit('setReferences', payload)
    },
    setSalaries ( {commit}, payload ) {
        commit('setSalaries', payload)
    },
    setPeriodicityArray ( {commit}, payload ) {
        commit('setPeriodicityArray', payload)
    },
    setBalance ( {commit}, payload ) {
        commit('setBalance', payload)
    },
    setFM100 ( {commit}, payload ) {
        commit('setFM100', payload)
    },
    setFM102 ( {commit}, payload ) {
        commit('setFM102', payload)
    },
    setWillingnessToPay ( {commit}, payload ) {
        commit('setWillingnessToPay', payload)
    },
    setConsolidatedBalance ( {commit}, payload ) {
        commit('setConsolidatedBalance', payload)
    },
    setCharacterAnalysis ( {commit}, payload ) {
        commit('setCharacterAnalysis', payload)
    },
    newGuarantor ( {commit} ) {
        commit('newGuarantor')
    },
    finishEvaluation ({commit}, payload) {
        commit('finishEvaluation', payload)
    },
    finishEvaluationRedirectTo ({commit}, payload) {
        commit('finishEvaluationRedirectTo', payload)
    },
    deleteCustomerStudy ( {commit}, payload ) {
        commit('deleteCustomerStudy', payload)
    },
    deleteGuarantorStudy ( {commit}, payload ) {
        commit('deleteGuarantorStudy', payload)
    },
    deleteGuarantors ( {commit}) {
        commit('deleteGuarantors')
    },
    deleteAssesment ( {commit}, payload ) {
        commit('deleteAssesment', payload)
    },


    /*Guarantors*/
    setGuarantorSalesData ({commit}, payload) {
        commit('setGuarantorSalesData', payload)
    },
    setGuarantorSalesDataComputed ({commit}, payload) {
        commit('setGuarantorSalesDataComputed', payload)
    },
    setGuarantorSalesDataPopulate ({commit}, payload) {
        commit('setGuarantorSalesDataPopulate', payload)
    },
    setGuarantorCostsProductLineItems ({commit}, payload) {
        commit('setGuarantorCostsProductLineItems', payload)
    },
    setGuarantorTotalCostsComputed ({commit}, payload) {
        commit('setGuarantorTotalCostsComputed', payload)
    },
    setGuarantorCatalogs ({commit}, payload) {
        commit('setGuarantorCatalogs', payload)
    },
    setGuarantorCatalogSales ({commit}, payload) {
        commit('setGuarantorCatalogSales', payload)
    },
    setGuarantorCatalogCosts ({commit}, payload) {
        commit('setGuarantorCatalogCosts', payload)
    },
    resetGuarantorSalesCosts ( {commit}) {
        commit('resetGuarantorSalesCosts')
    },
    setGuarantorActivityTypeSubcategory ({commit}, subcategory) {
        commit('setGuarantorActivityTypeSubcategory', subcategory)
    },
    setGuarantorCostsProductLine ({commit}, payload) {
        commit('setGuarantorCostsProductLine', payload)
    },
    setGuarantorCostsDataPopulate ({commit}, payload) {
        commit('setGuarantorCostsDataPopulate', payload)
    },
    setGuarantorCostsProductionItem ({commit}, payload) {
        commit('setGuarantorCostsProductionItem', payload)
    },
    setGuarantorGeneralCosts ({commit}, payload) {
        commit('setGuarantorGeneralCosts', payload)
    },
    setGuarantorTransportCosts ({commit}, payload) {
        commit('setGuarantorTransportCosts', payload)
    },
    setGuarantorMonthlyNumber ({commit}, payload) {
        commit('setGuarantorMonthlyNumber', payload)
    },
    setGuarantorCostsProductionItems ({commit}, payload) {
        commit('setGuarantorCostsProductionItems', payload)
    },
    setGuarantorPeriodicityArray ( {commit}, payload ) {
        commit('setGuarantorPeriodicityArray', payload)
    },
    setGuarantorOperatingExpenses ( {commit}, payload ) {
        commit('setGuarantorOperatingExpenses', payload)
    },
    setGuarantorInventory ( {commit}, payload ) {
        commit('setGuarantorInventory', payload)
    },
    setGuarantorReferences ( {commit}, payload ) {
        commit('setGuarantorReferences', payload)
    },
    setGuarantorCharacterAnalysis ( {commit}, payload ) {
        commit('setGuarantorCharacterAnalysis', payload)
    },
    setGuarantorBalance ( {commit}, payload ) {
        commit('setGuarantorBalance', payload)
    },
    resetAssesment ( {commit} ) {
        commit('resetAssesment')
    },
    resetBalance ( {commit} ) {
        commit('resetBalance')
    },
    setActualAssesment ( {commit}, payload ) {
        commit('setActualAssesment', payload)
    },
    setActualAssesmentStudy ( {commit}, payload ) {
        commit('setActualAssesmentStudy', payload)
    },
    setAssesmentEdit ( {commit}, payload ) {
        commit('setAssesmentEdit' ,payload)
    },
    setConnectivityState ( {commit}, payload ) {
        commit('setConnectivityState' ,payload)
    },
    setAlert ( {commit}, payload ) {
        commit('setAlert', payload)
    },
    setChangeLog ({commit}, payload) {
        commit('setChangeLog', payload)
    },
    setCreditSales ({commit}, payload) {
        commit('setCreditSales', payload)
    },
    setOldSurplus ({commit}, payload) {
        commit('setOldSurplus', payload)
    },
    setOldSales ({commit}, payload) {
        commit('setOldSales', payload)
    },
}
export default actions
